//
// client-search-typeahead.js
//
// Copyright (c) 2016 by Curalate, Inc.
//

/*global angular: false, moment: false, _: false */

(function() {
    "use strict";

    var curalate = angular.module('curalate');

    curalate.directive('clientSearchTypeahead', ['OpsService', function (OpsService) {
        return {
            restrict: 'E',
            scope: {
                ngModel: '=',
                required: '=ngRequired',
                attrName: '=',
                onSelect: '&',
                onSearch: '&?'
            },
            templateUrl: '/app/components/common/client-search-typeahead/client-search-typeahead.html',
            link: {
                pre: function (scope) {
                    scope.model = {};
                    scope.model.typeahead = {
                        currentQuery: function() {
                            return scope.model.currentQuery;
                        },
                        events: {
                            selected: function(ev, suggestion) {
                                scope.onSelect({ client: suggestion });
                            }
                        },
                        templates: {
                            suggestion: { url: '/app/components/common/client-search-typeahead/client-dropdown-item.html' }
                        },
                        searchClients: _.debounce(function(query, defer) {
                            OpsService.searchClients(query).then(function(res) {
                                defer.resolve(_(res).where({ isDeleted: false }));
                            });
                        }, 50)
                    };
                }
            }
        };
    }]);
})();
